import { call, put, takeEvery } from "redux-saga/effects";
import {
  routePricingAction,
  routePricingHRAction,
} from "../../api/route-pricing/routePricingAction";
import {
  setRoutePricingDataHR,
  setRoutePricingDataOW,
  setStatus,
} from "../../redux/route-pricing/route-pricing-slice";
import { toast } from "react-toastify";

function* routePricingOWSaga(action) {
  try {
    yield put(setStatus({ isLoading: true, isError: false, isLoaded: false }));

    console.log("Reached here");
    const res = yield call(routePricingAction, action.payload);

    if (res.status === 200) {
      yield put(
        setRoutePricingDataOW({
          routePricingData: res?.data ?? {},
        })
      );
      yield put(
        setStatus({ isLoading: false, isError: false, isLoaded: true })
      );
    }

    console.log(res, "res route pricing");
  } catch (error) {
    // toast.error(error.msg);
    yield put(setStatus({ isLoading: false, isError: true, isLoaded: false }));
    toast.error(error?.message || "Something went wrong");
  }
}

function* routePricingHRSaga(action) {
  try {
    yield put(setStatus({ isLoading: true, isError: false, isLoaded: false }));
    const res = yield call(routePricingHRAction, action.payload);

    console.log("Res --->", res);

    if (res.status === 200) {
      yield put(
        setRoutePricingDataHR({
          routePricingData: res?.data ?? {},
        })
      );
      yield put(
        setStatus({ isLoading: false, isError: false, isLoaded: true })
      );
    }
  } catch (error) {
    yield put(setStatus({ isLoading: false, isError: true, isLoaded: false }));
    toast.error(error.message || "something west wrong");
  }
}

export function* watchRoutePricingAsync() {
  yield takeEvery("ROUTE_PRICING_ONEWAY", routePricingOWSaga);
  yield takeEvery("ROUTE_PRICING_HOURLY", routePricingHRSaga);
}
